<template>
  <div class="boxBb">
    <resize-container :tabShow="tabShow">
      <div class="grid-content bg-purple" v-show="tabShow" slot="left">
        <tab-tree
          :data="viewTreeData"
          @changeCompany="changeCompany"
          @tabTreeDefault="tabTreeDefault"
          @tabTreeClick="tabTreeClick"
        ></tab-tree>
      </div>
      <div class="grid-content bg-purple">
        <div class="boxNew bgbox">
          <div class="time_box dn-content-bg">
            <time-search
              ref="timeSearch"
              :control="{ data: timeData }"
              @timeControlChange="timeControlChange"
              @timeControlClick="TimeControlClick"
            >
            </time-search>
          </div>
          <div class="contant_box">
            <div class="tableBox">
              <div
                class="table_"
                v-if="tableData.length != 0"
                ref="tablegrid"
                v-loading="load"
              >
                <el-table
                  id="table"
                  :data="tableData"
                  border
                  style="width: 100%"
                  height="100%"
                  highlight-current-row
                  size="small"
                  :header-cell-style="tableHeaderColor"
                >
                  <el-table-column
                    align="center"
                    type="index"
                    label="序号"
                    width="100"
                  ></el-table-column>
                  <el-table-column
                    prop="name"
                    sortable
                    label="名称"
                    align="left"
                    :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column
                    prop="sum"
                    sortable
                    label="统计项"
                    align="left"
                    :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column
                    prop="bq"
                    sortable
                    label="本期值"
                    align="right"
                  ></el-table-column>
                  <el-table-column
                    prop="tq"
                    sortable
                    label="同期值"
                    align="right"
                  ></el-table-column>
                  <el-table-column
                    prop="hq"
                    sortable
                    label="环期值"
                    align="right"
                  ></el-table-column>
                  <el-table-column
                    prop="tb"
                    sortable
                    label="同比"
                    align="right"
                  ></el-table-column>
                  <el-table-column
                    prop="hb"
                    sortable
                    label="环比"
                    align="right"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
import TabTree from "@/components/common/TabTree.vue";
import TimeSearch from "@/components/common/TimeSearch.vue";
import * as utils from "@/utils/index18.js";
import tree from "@/utils/tree.js";
import { formatTime, formatDate } from "@/utils/index18.js";
import dateTool from "@/utils/dateTool";
import { pseudoRandomBytes } from "crypto";
import { isNull, isUndefined } from "util";
import api from "@common/api/index.js";
import { findDataByParam } from "@/utils/index18.js";
import ResizeContainer from "@/components/common/resizeContainer.vue";

let allTimeData = [
  {
    type: "day",
    label: "日",
  },
  {
    type: "week",
    label: "周",
  },
  {
    type: "month",
    label: "月",
  },
  {
    type: "timeInterval",
    label: "时段",
  },
];
export default {
  data() {
    return {
      sui: "sdfsdfds",
      tabShow: true,
      viewTreeData: null,
      timeData: allTimeData,
      StandardCoalCoefficientOfElectricity: 1, //电折标系数
      CalibrationCoefficientOfNaturalGas: 1, //天然气折标系数
      leftTreeData: [],
      measureId: "", //计量点id
      startTime: "", //开始时间
      endTime: "", //结束时间
      companyID: "0",
      pointCode: "0", //测点编码
      pointNumber: "0", //测量编号
      nodeData: [], //选择的树节点
      selectNodes: [],
      timeType: [
        { value: "0", label: "日" },
        { value: "2", label: "月" },
        { value: "3", label: "时段" },
        { value: "5", label: "年" },
      ],
      checkarry: [], //树勾选数组    created mounted
      alarnclass: "alarnclass", //时段需要选分秒
      elem: { dateType: "0", startTime: "", endTime: "" },
      timeInterval: "toDay",
      treeTabObj: null,
      tableTj: [
        "总用电量(kW▪h)",
        "总用天然气量(m³)",
        "综合能耗(kgce)",
        "总产量(台)",
        "单台用电量(kW▪h/台)",
        "单台用天然气量(m³/台)",
        "单台综合能耗(kgce/台)",
      ],
      tableData: [],
      paramsData: [],
      load: true,
    };
  },
  created() {},
  methods: {
    /* 切换公司树 */
    changeCompany(companyId) {
      let vm = this;
      vm.tableData = [];
      vm.tableTj.map((item) => {
        //  a:“这哪个
        vm.tableData.push({
          name: "",
          sum: item,
          bq: "",
          tq: "",
          hq: "",
          tb: "",
          hb: "",
        });
      });
      api.frontEndPageCustomParam
        .getMyFrontEndPageCustomParam(
          vm.$store.state.user.currentCompanyId,
          "/report/bbgl-dfrc",
          null
        )
        .then((res) => {
          const viewTreeData = findDataByParam("viewTree", true, res.data);
          const foldCoefficient = findDataByParam(
            "foldCoefficient",
            true,
            res.data
          );
          foldCoefficient.forEach((obj) => {
            if (obj.name == "StandardCoalCoefficientOfElectricity") {
              vm.StandardCoalCoefficientOfElectricity = parseFloat(obj.value);
            }
            if (obj.name == "CalibrationCoefficientOfNaturalGas") {
              vm.CalibrationCoefficientOfNaturalGas = parseFloat(obj.value);
            }
          });
          vm.viewTreeData = viewTreeData;
        });
    },
    tabTreeDefault(data) {
      let vm = this;
      this.measureId = data.measureId;
      for (let i = 0; i < vm.tableData.length; i++) {
        vm.tableData[i].name = data.measureName;
      }
      vm.checkedNodes = [data];
      vm.getMeasureExpressions(vm.measureId);
    },
    tabTreeClick(data) {
      let vm = this;
      vm.measureId = data.measureId;
      for (let i = 0; i < vm.tableData.length; i++) {
        vm.tableData[i].name = data.measureName;
      }
      vm.checkedNodes = [data];
      vm.getMeasureExpressions(vm.measureId);
    },
    timeControlChange(e) {
      this.elem = e;
    },
    TimeControlClick(e) {
      let vm = this;
      this.elem = e;
      //拿取天然气计量点
      vm.getMeasureExpressions(vm.measureId);
    },
    //拿取天然气计量点
    getMeasureExpressions(nodeId) {
      let vm = this;
      vm.$api.measure.getMeasureExpressions(nodeId).then((res) => {
        let elem = vm.elem;
        vm.elem.dateType = elem.dateType;
        vm.startTime = elem.startTime;
        vm.endTime = elem.endTime;
        //环期
        let hqTime = utils.getCheckRepeatTime(
          vm.elem.startTime,
          vm.elem.dateType
        );
        //同期
        let tqTime = utils.getCheckBeforeTime(
          vm.elem.startTime,
          vm.elem.endTime,
          vm.elem.dateType
        );
        let dataendTime = new Date(elem.endTime);
        dataendTime.setDate(dataendTime.getDate() + 1);
        let start = elem.startTime; //开始时间
        let end = elem.endTime; //结束时间
        let startStr = hqTime.fromDate;
        let endStr = hqTime.toDate;
        let startStr1 = tqTime.fromDate;
        let endStr1 = tqTime.toDate;
        if (elem.dateType == "day") {
          this.timeParams(
            elem.startTime,
            elem.endTime,
            startStr,
            endStr,
            startStr1,
            endStr1,
            "tq"
          );
        } else if (elem.dateType == "month") {
          startStr = hqTime.fromDate;
          endStr = hqTime.toDate;
          startStr1 = tqTime.fromDate;
          endStr1 = tqTime.toDate;
          this.timeParams(
            elem.startTime,
            elem.endTime,
            startStr,
            endStr,
            startStr1,
            endStr1,
            "tq"
          );
        } else if (elem.dateType == "year") {
          endStr1 = vm.elem.startTime;
          //同期
          this.timeNewParams(
            vm.elem.startTime,
            vm.elem.endTime,
            startStr1,
            endStr1,
            "hq"
          );
        } else {
          var timestamp = Date.parse(start) / 1000;
          var timeend = Date.parse(end) / 1000;
          let timec = timeend - timestamp;
          let stt = timestamp - timec;
          let ett = timeend - timec;
          let startStr =
            dateTool.format(new Date(stt), "yyyy-MM-dd ") + "00:00:00"; //时段的环期开始时间
          let endStr =
            dateTool.format(new Date(ett), "yyyy-MM-dd ") + "00:00:00"; //时段的环期结束时间
          startStr1 = this.getNextYear(elem.startTime); // //  时段同期开始
          endStr1 = this.getNextYear(elem.endTime); // //  时段同期结束getNextYear
          this.timeParams(
            elem.startTime,
            elem.endTime,
            startStr,
            endStr,
            startStr1,
            endStr1,
            "tq"
          );
        }
        vm.elem = elem;
        let checkedKeys = [];
        for (let index = 0; index < vm.checkedNodes.length; index++) {
          const element = vm.checkedNodes[index];
          checkedKeys.push(element.measureId);
        }
      });
    },
    /**
     * 获取列表数据
     */
    getTableData(obj, year) {
      let vm = this;
      let apiArr = [];
      vm.load = true;
      setTimeout(() => {
        let { eleTq, yhqtTq, ctrTq, eleTqZ, yhqtTqZ } = {
          eleTq: null,
          yhqtTq: null,
          ctrTq: null,
          eleTqZ: null,
          yhqtTqZ: null,
        };
        if (year == "hq") {
          Promise.all(obj).then((res) => {
            vm.load = false;
            for (let i = 0; i < 5; i++) {
              this.tableData[i].tq = "-"; //同期值
              this.tableData[i].tb = "-"; //同比
            }
            vm.getTable(res);
          });
        } else {
          Promise.all(obj).then((res) => {
            let differ =
              new Date(vm.elem.endTime).getTime() -
              new Date(vm.elem.startTime).getTime();
            vm.load = false;
            //获取总用电量同期值
            vm.tableData[0].tq = isNull(res[2].data[0].value)
              ? "-"
              : res[2].data[0].value.toFixed(2);
            //产量同期值
            vm.tableData[3].tq = isNull(res[5].data[0].value)
              ? "-"
              : res[5].data[0].value.toFixed(2);
            /*液化气体同期值 */
            vm.tableData[1].tq = isNull(res[8].data[0].value)
              ? "-"
              : parseFloat(res[8].data[0].value).toFixed(2);
            eleTq = isNull(res[2].data[0].value) ? "-" : res[2].data[0].value;
            ctrTq = isNull(res[5].data[0].value) ? "-" : res[5].data[0].value;
            yhqtTq = isNull(res[8].data[0].value)
              ? "-"
              : parseFloat(res[8].data[0].value);
            let eleFoldTq =
              vm.tableData[0].tq * vm.StandardCoalCoefficientOfElectricity; //同期电量乘电量折标的值
            let qhqtFoldTq =
              vm.tableData[1].tq * vm.CalibrationCoefficientOfNaturalGas; //同期天然气乘折标的值
            if (isNaN(eleFoldTq) && isNaN(qhqtFoldTq)) {
              vm.tableData[2].tq = "-";
            } else if (isNaN(eleFoldTq)) {
              vm.tableData[2].tq = qhqtFoldTq.toFixed(2);
            } else if (isNaN(qhqtFoldTq)) {
              vm.tableData[2].tq = eleFoldTq.toFixed(2);
            } else {
              vm.tableData[2].tq = (
                parseFloat(eleFoldTq) + parseFloat(qhqtFoldTq)
              ).toFixed(2);
            }
            /* 单片用电量  电/产量*/
            vm.tableData[4].tq =
              vm.tableData[3].tq == 0
                ? 0
                : isNaN(vm.tableData[0].tq / vm.tableData[3].tq)
                ? "-"
                : (vm.tableData[0].tq / vm.tableData[3].tq).toFixed(2);
            /* 单片用天然气体量    天然气/产量*/
            vm.tableData[5].tq =
              vm.tableData[3].tq == 0
                ? 0
                : isNaN(vm.tableData[1].tq / vm.tableData[3].tq)
                ? "-"
                : (vm.tableData[1].tq / vm.tableData[3].tq).toFixed(2);
            /* 单片用电量 */
            eleTqZ =
              ctrTq == 0
                ? 0
                : isNaN(eleTq / ctrTq)
                ? "-"
                : (eleTq / ctrTq).toFixed(2);
            /* 单片用天然气量 */
            yhqtTqZ =
              ctrTq == 0
                ? 0
                : isNaN(yhqtTq / ctrTq)
                ? "-"
                : (yhqtTq / ctrTq).toFixed(2);
            //同期单片用电乘电折标
            let originalEleTq =
              eleTqZ * vm.StandardCoalCoefficientOfElectricity; //同期单片用电乘电折标
            let originalyhqtTq =
              yhqtTqZ * vm.CalibrationCoefficientOfNaturalGas; //同期单片用天然气乘折标
            if (isNaN(originalEleTq) && isNaN(originalyhqtTq)) {
              vm.tableData[6].tq = "-";
            } else if (isNaN(originalEleTq)) {
              vm.tableData[6].tq = originalWaterTq.toFixed(7);
            } else if (isNaN(originalyhqtTq)) {
              vm.tableData[6].tq = originalEleTq.toFixed(7);
            } else {
              vm.tableData[6].tq = (originalEleTq + originalyhqtTq).toFixed(7);
            }
            //同比
            for (let i = 0; i < vm.tableData.length; i++) {
              this.$nextTick(() => {
                if (vm.tableData[i].tb == "0%") {
                  vm.tableData[i].tb = "100%";
                }
                if (vm.tableData[i].tq == "-" || vm.tableData[i].bq == "-") {
                  vm.tableData[i].tb = "-";
                } else if (vm.tableData[i].tq == 0 && vm.tableData[i].bq == 0) {
                  vm.tableData[i].tb = "100%";
                } else if (vm.tableData[i].bq == 0) {
                  vm.tableData[i].tb = "-100%";
                } else if (vm.tableData[i].tq == 0) {
                  vm.tableData[i].tb = "100%";
                } else if (vm.tableData[i].tq && vm.tableData[i].bq) {
                  vm.tableData[i].tb =
                    (
                      ((vm.tableData[i].bq - vm.tableData[i].tq) /
                        vm.tableData[i].tq) *
                      100
                    ).toFixed(2) + "%";
                }
              });
            }
            vm.getTable(res);
          });
        }
      }, 1000);
    },
    //有天然气量
    getTable(res) {
      //  接口数据顺序 [电本 电环 电同 产本 产环 产同 天然气本 天然气环 天然气同]
      //获取总用电量本期值
      let vm = this;
      let { eleBq, ctrBq, yhqtBq, eleBqZ, yhqtBqZ } = {
        eleBq: null,
        ctrBq: null,
        yhqtBq: null,
        eleBqZ: null,
        yhqtBqZ: null,
      };
      let { eleHq, ctrHq, yhqtHq, eleHqZ, yhqtHqZ } = {
        eleHq: null,
        ctrHq: null,
        yhqtHq: null,
        eleHqZ: null,
        yhqtHqZ: null,
      };
      let differ =
        new Date(vm.elem.endTime).getTime() -
        new Date(vm.elem.startTime).getTime();
      //电量
      vm.tableData[0].bq = isNull(res[0].data[0].value)
        ? "-"
        : res[0].data[0].value.toFixed(2);
      //产量
      vm.tableData[3].bq = isNull(res[3].data[0].value)
        ? "-"
        : res[3].data[0].value.toFixed(2);
      //天然气
      vm.tableData[1].bq = isNull(res[6].data[0].value)
        ? "-"
        : parseFloat(res[6].data[0].value).toFixed(2);
      eleBq = isNull(res[0].data[0].value) ? "-" : res[0].data[0].value;
      ctrBq = isNull(res[3].data[0].value) ? "-" : res[3].data[0].value;
      yhqtBq = isNull(res[6].data[0].value) ? "-" : res[6].data[0].value;
      //环期
      //获取总用电量环期值
      vm.tableData[0].hq = isNull(res[1].data[0].value)
        ? "-"
        : res[1].data[0].value.toFixed(2);
      //获取总产量环期值
      vm.tableData[3].hq = isNull(res[4].data[0].value)
        ? "-"
        : res[4].data[0].value.toFixed(2);
      //获取天然气环期值
      vm.tableData[1].hq = isNull(res[7].data[0].value)
        ? "-"
        : parseFloat(res[7].data[0].value).toFixed(2);
      eleHq = isNull(res[1].data[0].value) ? "-" : res[1].data[0].value;
      ctrHq = isNull(res[4].data[0].value) ? "-" : res[4].data[0].value;
      yhqtHq = isNull(res[7].data[0].value)
        ? "-"
        : parseFloat(res[7].data[0].value);
      let eleFold =
        vm.tableData[0].bq * vm.StandardCoalCoefficientOfElectricity; //本期电量乘电量折标的值
      let yhqtFold = vm.tableData[1].bq * vm.CalibrationCoefficientOfNaturalGas; //本期天然气乘折标的值
      if (isNaN(eleFold) && isNaN(yhqtFold)) {
        vm.tableData[2].bq = "-";
      } else if (isNaN(eleFold)) {
        vm.tableData[2].bq = yhqtFold.toFixed(2);
      } else if (isNaN(yhqtFold)) {
        vm.tableData[2].bq = eleFold.toFixed(2);
      } else {
        vm.tableData[2].bq = (eleFold + yhqtFold).toFixed(2);
      }
      /* 单片用电本期 */
      vm.tableData[4].bq =
        vm.tableData[3].bq == 0
          ? 0
          : isNaN(vm.tableData[0].bq / vm.tableData[3].bq)
          ? "-"
          : (vm.tableData[0].bq / vm.tableData[3].bq).toFixed(5);
      /* 单片天然气本期 */
      vm.tableData[5].bq =
        vm.tableData[3].bq == 0
          ? 0
          : isNaN(vm.tableData[1].bq / vm.tableData[3].bq)
          ? "-"
          : (vm.tableData[1].bq / vm.tableData[3].bq).toFixed(5);
      eleBqZ = ctrBq == 0 ? 0 : isNaN(eleBq / ctrBq) ? "-" : eleBq / ctrBq;
      yhqtBqZ = ctrBq == 0 ? 0 : isNaN(yhqtBq / ctrBq) ? "-" : yhqtBq / ctrBq;
      let originalEle = eleBqZ * vm.StandardCoalCoefficientOfElectricity; //单片用电乘电折标
      let originalYhqt = yhqtBqZ * vm.CalibrationCoefficientOfNaturalGas; //单片天然气乘折标
      if (isNaN(originalEle) && isNaN(originalYhqt)) {
        vm.tableData[6].bq = "-";
      } else if (isNaN(originalEle)) {
        vm.tableData[6].bq = originalYhqt.toFixed(7);
      } else if (isNaN(originalYhqt)) {
        vm.tableData[6].bq = originalEle.toFixed(7);
      } else {
        vm.tableData[6].bq = (originalEle + originalYhqt).toFixed(7);
      }

      let eleFoldHq =
        vm.tableData[0].hq * vm.StandardCoalCoefficientOfElectricity; //环期期电量乘电量折标的值
      let yhqtFoldHq =
        vm.tableData[1].hq * vm.CalibrationCoefficientOfNaturalGas; //环期天然气乘折标的值
      if (isNaN(eleFoldHq) && isNaN(yhqtFoldHq)) {
        vm.tableData[2].hq = "-";
      } else if (isNaN(eleFoldHq)) {
        vm.tableData[2].hq = yhqtFoldHq.toFixed(2);
      } else if (isNaN(yhqtFoldHq)) {
        vm.tableData[2].hq = eleFoldHq.toFixed(2);
      } else {
        vm.tableData[2].hq = (yhqtFoldHq + eleFoldHq).toFixed(2);
      }
      /* 单片用电环期 */
      vm.tableData[4].hq =
        vm.tableData[3].hq == 0
          ? 0
          : isNaN(vm.tableData[0].hq / vm.tableData[3].hq)
          ? "-"
          : (vm.tableData[0].hq / vm.tableData[3].hq).toFixed(5);
      /* 单片天然气环期 */
      vm.tableData[5].hq =
        vm.tableData[2].hq == 0
          ? 0
          : isNaN(vm.tableData[1].hq / vm.tableData[3].hq)
          ? "-"
          : (vm.tableData[1].hq / vm.tableData[3].hq).toFixed(5);
      eleHqZ =
        ctrHq == 0
          ? 0
          : isNaN(eleHq / ctrHq)
          ? "-"
          : (eleHq / ctrHq).toFixed(2);
      yhqtHqZ =
        ctrHq == 0
          ? 0
          : isNaN(yhqtHq / ctrHq)
          ? "-"
          : (yhqtFoldHq / ctrHq).toFixed(2);
      let originalEleHq = eleHqZ * vm.StandardCoalCoefficientOfElectricity; //环期单片用电乘电折标
      let originalYhqtHq = yhqtHqZ * vm.CalibrationCoefficientOfNaturalGas; //环期单片天然气乘折标
      if (isNaN(originalEleHq) && isNaN(originalYhqtHq)) {
        vm.tableData[6].hq = "-";
      } else if (isNaN(originalEleHq)) {
        vm.tableData[6].hq = originalYhqtHq.toFixed(7);
      } else if (isNaN(originalYhqtHq)) {
        vm.tableData[6].hq = originalEleHq.toFixed(7);
      } else {
        vm.tableData[6].hq = (originalEleHq + originalYhqtHq).toFixed(7);
      }
      for (let i = 0; i < vm.tableData.length; i++) {
        //环比
        this.$nextTick(() => {
          if (vm.tableData[i].hb == "0%") {
            vm.tableData[i].hb = "100%";
          }
          if (vm.tableData[i].hq == "-" || vm.tableData[i].bq == "-") {
            vm.tableData[i].hb = "-";
          } else if (vm.tableData[i].hq == 0 && vm.tableData[i].bq == 0) {
            vm.tableData[i].hb = "100%";
          } else if (vm.tableData[i].bq == 0) {
            vm.tableData[i].hb = "-100%";
          } else if (vm.tableData[i].hq == 0) {
            vm.tableData[i].hb = "100%";
          } else if (vm.tableData[i].hq && vm.tableData[i].bq) {
            vm.tableData[i].hb =
              (
                ((vm.tableData[i].bq - vm.tableData[i].hq) /
                  vm.tableData[i].hq) *
                100
              ).toFixed(2) + "%";
          }
        });
      }
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      //改表头颜色
      if (rowIndex === 0) {
        return "background-color: #dbdbdb;color: #666;";
      }
    },
    timeNewParams(bStart, bEnd, hStart, hEnd, hq) {
      //获取年和时段
      let vm = this;
      let apiArr = [];
      apiArr.push(
        vm.$api.quantity.getQuantity2(
          JSON.stringify([
            {
              measureId: vm.measureId,
              pointNumber: vm.pointNumber,
              pointCode: "100229",
            },
          ]),
          bStart,
          bEnd,
          ""
        )
      );
      apiArr.push(
        vm.$api.quantity.getQuantity2(
          JSON.stringify([
            {
              measureId: vm.measureId,
              pointNumber: vm.pointNumber,
              pointCode: "100701",
            },
          ]),
          bStart,
          bEnd,
          ""
        )
      );
      apiArr.push(
        vm.$api.quantity.getQuantity2(
          JSON.stringify([
            {
              measureId: vm.measureId,
              pointNumber: vm.pointNumber,
              pointCode: "100701",
            },
          ]),
          bStart,
          bEnd,
          ""
        )
      );
      apiArr.push(
        vm.$api.quantity.getQuantity2(
          JSON.stringify([
            {
              measureId: vm.measureId,
              pointNumber: vm.pointNumber,
              pointCode: "100701",
            },
          ]),
          bStart,
          bEnd,
          ""
        )
      );
      vm.getTableData(apiArr, hq);
    },
    //根据日月传参数
    timeParams(bStart, bEnd, hStart, hEnd, tStart, tEnd, hq) {
      let vm = this;
      let apiArr = [];
      apiArr.push(
        vm.$api.quantity.getQuantity2(
          JSON.stringify([
            {
              measureId: vm.measureId,
              pointNumber: vm.pointNumber,
              pointCode: "100229",
            },
          ]),
          bStart,
          bEnd,
          ""
        )
      );
      apiArr.push(
        vm.$api.quantity.getQuantity2(
          JSON.stringify([
            {
              measureId: vm.measureId,
              pointNumber: vm.pointNumber,
              pointCode: "100229",
            },
          ]),
          hStart,
          hEnd,
          ""
        )
      );
      apiArr.push(
        vm.$api.quantity.getQuantity2(
          JSON.stringify([
            {
              measureId: vm.measureId,
              pointNumber: vm.pointNumber,
              pointCode: "100229",
            },
          ]),
          tStart,
          tEnd,
          ""
        )
      );
      apiArr.push(
        vm.$api.quantity.getQuantity2(
          JSON.stringify([
            {
              measureId: vm.measureId,
              pointNumber: vm.pointNumber,
              pointCode: "100701",
            },
          ]),
          bStart,
          bEnd,
          ""
        )
      );
      apiArr.push(
        vm.$api.quantity.getQuantity2(
          JSON.stringify([
            {
              measureId: vm.measureId,
              pointNumber: vm.pointNumber,
              pointCode: "100701",
            },
          ]),
          hStart,
          hEnd,
          ""
        )
      );
      apiArr.push(
        vm.$api.quantity.getQuantity2(
          JSON.stringify([
            {
              measureId: vm.measureId,
              pointNumber: vm.pointNumber,
              pointCode: "100701",
            },
          ]),
          tStart,
          tEnd,
          ""
        )
      );
      apiArr.push(
        vm.$api.quantity.getQuantity2(
          JSON.stringify([
            {
              measureId: vm.measureId,
              pointNumber: "2",
              pointCode: "100401",
            },
          ]),
          bStart,
          bEnd,
          ""
        )
      );
      apiArr.push(
        vm.$api.quantity.getQuantity2(
          JSON.stringify([
            {
              measureId: vm.measureId,
              pointNumber: "2",
              pointCode: "100401",
            },
          ]),
          hStart,
          hEnd,
          ""
        )
      );
      apiArr.push(
        vm.$api.quantity.getQuantity2(
          JSON.stringify([
            {
              measureId: vm.measureId,
              pointNumber: "2",
              pointCode: "100401",
            },
          ]),
          tStart,
          tEnd,
          ""
        )
      );
      this.getTableData(apiArr, hq);
    },
    //时段算总量的和
    getall(resArr) {
      let total = null; //总值
      let ele = null;
      let resData = [{ value: "" }];
      let res = JSON.parse(JSON.stringify(resArr));
      for (let i = 0; i < res.length; i++) {
        if (!isNaN(res[i].value) && !total) {
          total = res[0].value;
        } else {
          total += res[i].value;
        }
      }
      res.value = total;
      return res;
    },
    // 获取指定日期的上一月，下一月
    getNextMonth(date) {
      let hqDate1 = new Date(date);
      hqDate1.setMonth(hqDate1.getMonth() - 1);
      return formatDate(hqDate1, "yyyy-MM-dd") + " 00:00:00";
    },
    getNextYear(date) {
      //上一年
      let tqDate = new Date(date);
      tqDate.setFullYear(tqDate.getFullYear() - 1);
      return formatDate(tqDate, "yyyy-MM-dd") + " 00:00:00";
    },
    bindExportExc() {
      //表格导出
      let name = "报表管理";
      utils.exportExcel("table", name, this.elem.startTime);
    },
    //树点击事件
    bindTreeClick(data) {
      let vm = this;
      vm.measureId = data.id;
      // vm.getMeasureExpressions(vm.measureId)
      for (let i = 0; i < vm.tableData.length; i++) {
        vm.tableData[i].name = data.label;
      }
      vm.getSearchElem(vm.elem);
    },
    bindTreeChange(nodes, ids) {},
    handleCurrentChange(val) {},
    bindGetTreeTabCode(e) {
      let vm = this;
      vm.pointCode = e.point_code;
      vm.$api.view.getViewTreeNodes(e.code).then((res) => {
        let arr = [];
        let nodes = [];

        // vm.getMeasureExpressions(vm.measureId)
        for (let index = 0; index < res.data.length; index++) {
          const element = res.data[index];
          arr.push(element.measureId);
          nodes.push({
            id: element.measureId,
            label: element.measureName,
          });
        }
        vm.leftTreeData = utils.creatTreeData(res.data, 0);
        setTimeout(() => {
          vm.$refs.tree.setTreeNodeSelect(vm.leftTreeData[0].children[0].id); //默认选择第一个节点
        }, 200);
        vm.measureId = vm.leftTreeData[0].children[0].id;
        //全选节点
        vm.checkedKeys = tree.sortTreeDataByKeys(vm.leftTreeData, arr);
        vm.checkedNodes = nodes;
        vm.elem = vm.$refs.search.getElem();
        vm.elem.dataType = vm.dataType;
        // vm.getTableData(1);
        vm.getSearchElem(vm.elem);
        for (let i = 0; i < vm.tableData.length; i++) {
          vm.tableData[i].name = res.data[0].measureName;
        }
      });
    },
  },
  components: { TabTree, TimeSearch, ResizeContainer },
};
</script>
<style lang="scss">
.boxBb {
  .el-table .cell {
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    line-height: 23px;
    padding-right: 10px;
    font-size: 14px;
  }
}
</style>
<style lang="scss" scoped>
.boxBb {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  display: flex;
}
.tree-content {
  min-width: 200px;
  margin-right: 14px;
}
.boxNew {
  width: 100%;
  color: #000;
  box-sizing: border-box;
}
.grid-content {
  width: 100%;
  height: 100%;
  display: flex;
}
.bgbox {
  padding-top: 0;
  box-sizing: border-box;
  padding: 0;
  // height: 789;
  display: flex;
  flex-flow: column;
  flex: 1;
}
.time_box {
  width: 100%;
  margin-bottom: 14px;
}
.contant_box {
  background: #fff;
  padding: 14px;
  box-sizing: border-box;
  border: 1px solid #eee;
  border-radius: 5px;
  display: flex;
  flex-flow: column;
  height: calc(100% - 66px);
  overflow: auto;
}
.tableBox {
  display: flex;
  height: 100%;
}
.table_ {
  display: flex;
  flex: 1;
  overflow: hidden;
}
.box_btn {
  height: 40px;
  width: 100%;
  line-height: 40px;
  display: flex;
  align-items: flex-end;
  border-bottom: 2px solid #00368e;
}
.box_btn p {
  color: #000;
  height: 30px;
  width: 96px;
  line-height: 30px;
  text-align: center;
  border: 1px solid #f5f5f5;
  border-bottom: none;
  cursor: pointer;
}
.box_btn .active {
  background: #00368e;
  color: #fff;
}
.box_con {
  position: absolute;
  top: 50px;
  bottom: 0px;
  width: 100%;
  display: flex;
}
.box_con_ {
  position: absolute;
  top: 45px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  overflow: hidden;
}
.chart_box {
  position: absolute;
  top: 10px;
  width: 100%;
  height: 600px;
  overflow: hidden;
}
.table_box {
  position: absolute;
  top: 615px;
  width: 100%;
  height: auto;
}
.charts {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.elechart_box {
  width: 100%;
  height: auto;
}
.eletable_box {
  width: 100%;
  height: auto;
}
</style>
